import React from "react";
import Modal from "@/components/Modal";
import ImportGroupContent from "./Import";
import { useGroupDeviceState } from "@/containers/CompanyDevice/Provider";

function ImportGroupDialog({
  title = "上传设备",
  open,
  groupId,
  onSuccess,
  onClose,
  type
}) {
  const { currentGroup } = useGroupDeviceState();

  return (
    <>
      <Modal
        title={title}
        width={500}
        open={open}
        onClose={onClose}
        footer={null}
      >
        <ImportGroupContent
          groupId={groupId}
          onSuccess={onSuccess}
          onCancel={onClose}
          currentGroup={currentGroup}
          type={type}
          title={title}
        />
      </Modal>
    </>
  );
}

export default ImportGroupDialog;
